import { createTelemetry, createTelemetryObject } from '@shared/core';

const registryChecklistTelemetry = createTelemetryObject({
  actions: {
    onChecklistSectionExpandClicked: ({ section }: { section: string }) => {
      return {
        action: 'ChecklistSectionExpand',
        actionType: 'click',
        category: 'registry',
        extraInfo: {
          section,
          checklist: 'registry',
        },
      };
    },
    onChecklistItemClicked: ({ item }: { item: string }) => {
      return {
        action: 'ChecklistItem',
        actionType: 'click',
        category: 'registry',
        extraInfo: {
          item,
          checklist: 'registry',
        },
      };
    },
    onChecklistItemCheckClicked: ({ state, item }: { state: 'checked' | 'unchecked'; item: string }) => {
      return {
        action: 'ChecklistItemCheck',
        actionType: 'click',
        category: 'registry',
        extraInfo: {
          item,
          state,
          checklist: 'registry',
        },
      };
    },
    onChecklistTooltipShown: ({ page }: { page: string }) => {
      return {
        action: 'ChecklistTooltipShown',
        category: 'registry',
        page,
      };
    },
    onChecklistTooltipRespond: ({ label }: { label: string }) => {
      return {
        action: 'ChecklistTooltipRespond',
        actionType: 'click',
        category: 'registry',
        label,
      };
    },
  },
});

const { TelemetryProvider, useTelemetry } = createTelemetry(registryChecklistTelemetry, { eventId: '' });

export { TelemetryProvider, useTelemetry as useRegistryChecklistTelemetry };

export type registryChecklistTelemetryObject = ReturnType<typeof useTelemetry>;
